function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrustyouBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 464.861,
    height: 167.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M-27.8-97.3h-92.9l-39.8 34.8V-230h133v132.7z",
    style: {
      fill: "#2a5caa"
    },
    transform: "translate(492.36 230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-172.1-97.3h-93.2l-39.8 34.8V-230h133z",
    style: {
      fill: "#2a5caa"
    },
    transform: "translate(470.732 230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-316.4-97.3h-92.9l-39.8 34.8V-230h133z",
    style: {
      fill: "#2a5caa"
    },
    transform: "translate(449.1 230)"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustyouBubbles);
export default __webpack_public_path__ + "static/media/trustyou-bubbles.a8201faa9dc613158303c3ed92fad250.svg";
export { ForwardRef as ReactComponent };